import React, { useCallback } from 'react';

import { AIMateAnalyticsContext } from '@atlaskit/analytics-namespaced-context/AIMateAnalyticsContext';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { useAnalytics } from '@atlassian/conversation-assistant-instrumentation/controllers/analytics';
import {
	RovoTargetingAudienceInitializer,
	RovoTargetingAudienceProvider,
} from '@atlassian/conversation-assistant-service/services/rovo-targeting-audience/provider';

const ReadinessInitializer = () => {
	const { sendAnalyticsEvent } = useAnalytics();
	const emit = useCallback<React.ComponentProps<typeof RovoTargetingAudienceInitializer>['emit']>(
		(event) => {
			sendAnalyticsEvent({ eventType: 'operational', ...event.data });
		},
		[sendAnalyticsEvent],
	);
	return <RovoTargetingAudienceInitializer emit={emit} />;
};

export const RovoTargetingScope = ({
	children,
	productKey,
	accountId,
	siteId,
	hasRovoAccess,
}: React.PropsWithChildren<{
	productKey: string;
	accountId?: string;
	siteId?: string;
	hasRovoAccess: boolean;
}>): React.JSX.Element => {
	const gateEnabled =
		productKey === 'confluence' && hasRovoAccess && fg('confluence_rovo_chat_targeting_readiness');
	return (
		<RovoTargetingAudienceProvider
			productKey={productKey}
			accountId={accountId}
			siteId={siteId}
			hasRovoAccess={hasRovoAccess}
			gateEnabled={gateEnabled}
		>
			<AIMateAnalyticsContext data={{ source: 'rovoTargeting' }}>
				<ReadinessInitializer />
			</AIMateAnalyticsContext>
			{children}
		</RovoTargetingAudienceProvider>
	);
};
